/**
 * localStorage 데이터 마이그레이션 모듈입니다.
 *
 * @remarks
 * 앱 버전 업데이트 시 이전 버전의 localStorage 데이터를 정리하거나
 * 새로운 형식으로 변환하는 데 사용됩니다.
 * 차트 설정, 그리드 상태 등 캐시된 설정을 초기화합니다.
 */
import { InvestMode } from '@bit-box/common';

/**
 * localStorage 마이그레이션을 수행합니다.
 *
 * @remarks
 * dbVersion을 확인하여 필요한 경우 오래된 키들을 정리합니다.
 * 지갑 잔고 입력값은 매번 초기화됩니다.
 */
export function migrateStorage() {
  const version = Number(localStorage.getItem('dbVersion') || '0');
  const NEW_VERSION = 16;
  if (version < NEW_VERSION) {
    // chartConfig으로 시작하는 키들을 모두 삭제
    // chartOptions으로 시작하는 키들을 모두 삭제
    // grid-state로 끝나는 키들을 모두 삭제
    const keys = Object.keys(localStorage).filter(
      key =>
        key.startsWith('chartConfig') ||
        key.startsWith('chartOptions') ||
        key.startsWith('chart.timeframes') ||
        key.endsWith('grid-state') ||
        key.startsWith('lastSelectedShapesByCategory_') ||
        key.startsWith('lastShapeProperties') ||
        key.startsWith('hiddenIndicators') ||
        key.startsWith('chart.widths') ||
        key.startsWith('chartInfos_') ||
        key.startsWith('shapes_') ||
        key.startsWith('chart-below-') ||
        key.startsWith('shapeProps'),
    );
    keys.forEach(key => localStorage.removeItem(key));
  }

  // 지갑 잔고, 씨드 입력 초기화
  localStorage.removeItem(`balanceInput_${InvestMode.REAL}`);
  localStorage.removeItem(`balanceInput_${InvestMode.SIMULATION}`);
  localStorage.removeItem(`balanceInput_${InvestMode.BACKTEST}`);
  localStorage.setItem('dbVersion', NEW_VERSION.toString());
}
